<template>
  <div class="notifications-page">
    <h1>{{ $t('kpi.s109') }}</h1>
    <div class="notifications-body">
      <div class="coupontable-top">     
        <el-select v-model="taskid" @change="changeBrand(taskid)" style="width:100%;">
          <el-option 
            v-for="item in brands" 
            :key="item.taskid" 
            :label="item.name" 
            :value="item.taskid"
          ></el-option>
        </el-select>
      </div>
      <div class="coupontable" v-loading="loading">  
        <table v-if="showtable">
          <tr class="coupontable-header">
            <td>
              打折类型\渠道
            </td>
            <td>
              <div class="coupontable-channel" v-for="item in available" :key="item">
                <span>{{ setChannel(item).name }}</span><i :class="'channelicon ' + setChannel(item).src"></i>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              多件打折
              <el-tooltip class="item" effect="dark" :content="$t('kpi.s107')" placement="top">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </td>
            <td>
              <el-checkbox-group v-model="checkdiscount">
                <el-checkbox 
                  v-for="item in available" 
                  :key="item" 
                  :label="item" 
                  :disabled="availablechannel.indexOf(item * 1) == -1 ? true : false"
                ></el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
          <tr>
            <td>
              满减
            </td>
            <td>
              <el-checkbox-group v-model="checkreduce">
                <el-checkbox 
                  v-for="item in available" 
                  :key="item" 
                  :label="item"
                  :disabled="availablechannel.indexOf(item * 1) == -1 ? true : false"
                ></el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
          <tr>
            <td>
              复购券
            </td>
            <td>
              <el-checkbox-group v-model="checkrepurchase">
                <el-checkbox 
                  v-for="item in available" 
                  :key="item" 
                  :label="item"
                  :disabled="availablechannel.indexOf(item * 1) == -1 ? true : false"
                ></el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
          <tr v-if="channellists.includes('3')">
            <td>
              优惠券类型
              <el-tooltip class="item" effect="dark" :content="$t('kpi.n1')" placement="top">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </td>
            <td>
              <el-select style="width: 100px;" v-model="jdcoupontypestr" size="mini">
                <el-option v-for="item in jdcoupontype" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="text-align: center;">
              <el-button type="primary" size="small" @click="confirmSet()">确定</el-button>
            </td>
          </tr>
        </table>
        <div class="coupontable-tips">
          <p>
            <!-- <i v-for="item in unavailable" :key="item" :class="'channelicon ' + setChannel(item).src"></i>  -->
            仅显示支持优惠券设定的渠道
          </p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      subid: this.$route.params.Id,
      taskid: '',
      brands: [],
      couponsetting: {
        discount: '2'
      },
      email: JSON.parse(localStorage.getItem("email")).val,
      channellists: [],
      discount: '',
      reduce: '',
      checkdiscount: [],
      checkreduce: [],
      checkrepurchase: [],
      availablechannel: [3, 30, 45, 52],
      loading: true,
      available: [],
      unavailable: [],
      showtable: true,
      jdcoupontype: [{
        /*couponType 1:店铺券 2:平台券0默认全部;针对京东*/
        name: "全部",
        value: 0
      },{
        name: "店铺券",
        value: 1
      },{
        name: "平台券",
        value: 2
      }],
      jdcoupontypestr: 0
    }
  },

  mounted(){
    let that = this
    let _price = JSON.parse(localStorage.getItem("price")).val
    that.brands = _price
    _price.map(item => {
      if(item.subid == that.subid){
         that.taskid = item.taskid
      }
    })
    that.getTaskdiscounts()
  },

  methods: {

    /**
     * 切换项目
     */
    changeBrand: function(tid){
      this.brands.map(item => {
        if(item.taskid == tid){
          this.taskid = item.subid
        }
      })
      this.$router.push({name: 'CouponSetting', params: {Id: this.taskid}})
    },

    /**
     * 初始化基本信息
     */
    getTaskdiscounts: function(){
      let that = this
      let url = that.API_URL + '/v3/notification/taskdiscount?taskid=' + that.taskid
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          that.channellists = data.result[0].ChannelIDList.split(',')
          let _ck1 = data.result[0].discountChannel != null ? JSON.parse(JSON.stringify(data.result[0].discountChannel.split(','))) : []
          let _ck2 = data.result[0].reduceChannel != null ? JSON.parse(JSON.stringify(data.result[0].reduceChannel.split(','))) : []
          let _ck3 = data.result[0].repurchaseChannel != null ? JSON.parse(JSON.stringify(data.result[0].repurchaseChannel.split(','))) : []
          let _newcheck1 = []
          let _newcheck2 = []
          let _newcheck3 = []
          for(let i=0; i<_ck1.length; i++){
            if(that.availablechannel.indexOf(_ck1[i] * 1) != -1){
              _newcheck1.push(_ck1[i])
            }
          }
          for(let i=0; i<_ck2.length; i++){
            if(that.availablechannel.indexOf(_ck2[i] * 1) != -1){
              _newcheck2.push(_ck2[i])
            }
          }
          for(let i=0; i<_ck3.length; i++){
            if(that.availablechannel.indexOf(_ck3[i] * 1) != -1){
              _newcheck3.push(_ck3[i])
            }
          }
          that.checkdiscount = _newcheck1
          that.checkreduce = _newcheck2
          that.checkrepurchase = _newcheck3
          
          let _unavailable = []
          let _available = []
          for(let i=0; i<that.channellists.length; i++){
            if(that.availablechannel.indexOf(that.channellists[i] * 1) == -1){
              _unavailable.push(that.channellists[i])
            }
            if(that.availablechannel.indexOf(that.channellists[i] * 1) != -1){
              _available.push(that.channellists[i])
            }
          }
          that.unavailable = _unavailable
          that.available = _available
          if(_unavailable.length == that.channellists.length){
            that.showtable = false
          }

          that.jdcoupontypestr = data.result[0].couponType

          that.loading = false
        },
        error: function(response) {
          console.log('getTaskdiscounts', response)
        }
      })
    },

    /**
     * 确认设置
     */
    confirmSet: function(){
      let that = this
      let url = that.API_URL + '/v3/notification/setdiscount'
      let _query = {
        discount: that.checkdiscount != '' && that.checkdiscount != [] ? 1 : 2,
        discountChannel: that.checkdiscount.join(','),
        reduce: that.checkreduce != '' && that.checkreduce != [] ? 1 : 2,
        reduceChannel: that.checkreduce.join(','),
        repurchase: that.checkrepurchase != '' && that.checkrepurchase != [] ? 1 : 2,
        repurchaseChannel: that.checkrepurchase.join(','),
        taskid: that.taskid,
        email: that.email,
        couponType: that.jdcoupontypestr
      }
      $.ajax({
        url: url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: _query,
        success: function(data) {
          console.log(data)
          that.$message({
            type: 'success',
            message: '设定成功！'
          })
        },
        error: function(response) {
          console.log(response)
        }
      })
    },
    
  },

}
</script>